module.exports = __webpack_public_path__ + "static/media/DinningArea.710e140f.webp";